export const ROWS_THRESHOLD_COLORS = {
  BAD: "outside-threshold",
  GOOD: "within-threshold",
};

export const ALLOWED_METRIC_TYPES = [
  "avg",
  "cnt",
  "cnt_distinct",
  "cnt_values",
  "max",
  "min",
  "nan_cnt",
  "null_pct",
  "pct_distinct",
  "pct_unique",
  "stddev",
  "meta_numOutputBytes",
  "meta_numOutputRows",
  "meta_numPartitions",
  "meta_filesSize",
  "schema_cnt",
  "num_schema_changes",
  "duration",
  "driver_max_used_memory",
  "driver_max_memory_utilization",
  "executor_max_used_memory",
  "executor_max_memory_utilization",
  "memory_time",
  "process_time",
  "used_vcore_time",
  "vcore_time",
  "num_tfs",
];
